import clsx from 'clsx';
import { isNativeAppWebview } from 'core';
import { useTranslate } from 'core/hooks/useTranslate';
import { useUser } from 'core/lite/hooks/useUser';
import TextLink from 'core/modules/atoms/TextLink';
import React from 'react';
import './AnalyticsErrorState.scss';

/**
 * Uses the same visual style as ContentNotFoundView
 */
const AnalyticsErrorState = () => {
  const { t } = useTranslate();
  const { user } = useUser();

  function closeWebview() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('closeWebview');
    }
  }

  return (
    <div className="analytics-error-state">
      <div className="analytics-error-state__content">
        <div className="analytics-error-state__image">
          <img src="" className={clsx('analytics-error-state__image-error', 'analytics-error-state__image-error--teacher')} alt="Error" />
        </div>
        <div className="analytics-error-state__texts">
          <span className="analytics-error-state__texts-title">{t('common:Oops! This page is not available')}</span>
          <span className="analytics-error-state__texts-subtitle">{t('common:The content might have been deleted')}</span>
        </div>
        {user?.source !== 'lti' && (
          <div className="analytics-error-state__back">
            <TextLink
              onClick={isNativeAppWebview() ? closeWebview : undefined}
              to={isNativeAppWebview() ? undefined : '/home'}
              text={t('common:Go to homepage')}
              icon="arrow-back"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalyticsErrorState;
